import React from "react";
import "../Home/Home.css";
// import Header from "../Header/Header";
// import Footer from "../Footer/Footer";
import { motion as m } from "framer-motion";

const Blog6 = () => {
  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 0.5, 1] }}
      transition={{ duration: 0.9, ease: "easeIn" }}
      style={{ willChange: "opacity" }}
    >
      {/* <Header /> */}
      <div className="bg-white dark:bg-black dark:text-white transition-all duration-300 ease-in-out">
        {/* Banner */}
        <div className="px-5 lg:px-[7%] 2xl:px-[13%] py-10 pt-36 sm:pt-32">
          <div className="flex justify-center items-center py-5 w-full bg-gray-100 text-gray-900 dark:bg-neutral-800 border border-gray-100 dark:border-gray-800 text-left p-3 dark:text-gray-50 text-base font-bold rounded-lg transition-all duration-200 ease-in-out">
            <div className="grid grid-cols-1 sm:grid-cols-[200px_auto] gap-2 sm:gap-5 sm:justify-center w-full">
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d1d4a919-bcbb-427c-2396-fab233d11700/public" //Init_Blog6.webp
                alt="Img"
                className="flex justify-end w-36 sm:w-48 -mt-10 sm:mt-0 sm:-mb-20 shadow-custom dark:shadow-white"
              />

              <p
                className="font-light capitalize mt-2 text-2xl lg:text-3xl transition-all duration-200 ease-in-out"
                style={{ lineHeight: 1.5 }}
              >
                <span className="font-semibold">
                  Is Shopify Still the Top <br className="hidden md:block" />{" "}
                  E-Commerce Platform in 2025?
                </span>
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="px-5 lg:px-[10%] 2xl:px-[15%] pt-0 pb-10 sm:py-10 space-y-6 text-justify">
          <p>
            In the ever-evolving landscape of e-commerce, choosing the right
            platform is crucial for achieving business success. By 2025, Shopify
            has established itself as a leading option, but is it still the best
            choice for online retailers?
          </p>

          <hr className="mx-5 border-t border-teal-500 dark:border-teal-600" />

          <div className="space-y-3">
            <p className="font-bold">Shopify's Ongoing Advantages</p>

            <p>
              • User-Friendly Interface: Shopify provides an easy-to-navigate
              platform that allows merchants to effortlessly create and manage
              their online stores.
            </p>

            <p>
              • Robust App Ecosystem: With a wide selection of plugins and
              integrations, Shopify enables businesses to tailor their stores to
              fit unique requirements.
            </p>

            <p>
              • Scalability: Shopify serves businesses of all sizes, offering
              the adaptability needed to expand operations as the business
              evolves.
            </p>
          </div>

          <div className="space-y-3">
            <p className="font-bold">Emerging Competitors and Alternatives</p>

            <p>
              While Shopify continues to be a leading option, a number of
              alternatives have started to make their mark:
            </p>

            <p>
              • BigCommerce: Renowned for its strong SEO capabilities and
              flexibility, BigCommerce attracts businesses that want greater
              control over their online presence.
            </p>

            <p>
              • WooCommerce: This WordPress plugin provides a wide range of
              customisation options, making it perfect for those with particular
              technical needs.
            </p>

            <p>
              • Custom E-Commerce Solutions: For companies with distinct
              requirements, creating a custom platform allows for total control
              over both functionality and design.
            </p>
          </div>

          <hr className="mx-5 border-t border-teal-500 dark:border-teal-600" />

          <p>
            Shopify continues to be a leading e-commerce platform in 2025, but
            options like BigCommerce, WooCommerce, and custom-built solutions
            provide valuable flexibility. The best choice will depend on your
            customisation, budget, and scalability requirements.
          </p>

          <p>
            At <span className="underline">inittechnology.co</span>, we focus on
            Shopify development, e-commerce solutions, and high-performance
            websites. Whether you're looking for a Shopify store or a tailored
            e-commerce platform, we’re here to help. Let’s work together to
            achieve your online success!
          </p>

          <br />
          <br />

          <div className="text-sm">
            <p className="font-semibold">Naju.K</p>
            <p>February 26, 2025 ∙ 4 mins read</p>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </m.div>
  );
};

export default Blog6;
